<app-banner [links]="bannnerLinks"></app-banner>

<app-location-alert (locationActivatedChange)="onLocationActivated($event)"></app-location-alert>

<!-- Section navigation for small screens as text links, below bannerlinks -->
<div class="flex justify-center gap-4 mb-3 md:hidden text-sm font-semibold">
  <a [routerLink]="['/', selectedCountry?.code?.toLowerCase(), 'medecins']" [ngClass]="{
      'text-primary': currentSection === 'medecins',
      'text-gray-500': currentSection !== 'medecins'
    }">Professionnels</a>
  <span class="text-gray-300">|</span>
  <a [routerLink]="['/', selectedCountry?.code?.toLowerCase(), 'structures']" [ngClass]="{
      'text-primary': currentSection === 'structures',
      'text-gray-500': currentSection !== 'structures'
    }">Structures</a>
  <span class="text-gray-300">|</span>
  <a [routerLink]="['/', selectedCountry?.code?.toLowerCase(), 'pharmacies']" [ngClass]="{
      'text-primary': currentSection === 'pharmacies',
      'text-gray-500': currentSection !== 'pharmacies'
    }">Pharmacies</a>
</div>

<div class="container" [ngClass]="{
    'mt-3!': currentTheme === 'eyone',
    '-mt-16': currentTheme === 'dpp'
  }">
  <app-search-and-filtrer></app-search-and-filtrer>
</div>

<!-- Liste des médecins -->
<div class="container mt-8 pb-10!">
  <!-- Skeleton loading pour les cartes de médecins -->
  <div *ngIf="loading" class="space-y-4">
    <div class="grid grid-cols-1 gap-6 mt-7">
      <app-doctor-skeleton *ngFor="let item of [1,2,3,4,5]"></app-doctor-skeleton>
    </div>
  </div>

  <!-- Message d'erreur -->
  <div *ngIf="error" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
    {{ error }}
  </div>

  <!-- Liste des médecins -->
  <div *ngIf="!loading && doctors.length > 0" class="space-y-4">
    <div class="flex justify-between items-center mb-5 mt-2 opacity-50">
      <span class="text-[12px] text-gray-800">
        {{ totalItems }} médecin{{ totalItems > 1 ? "s" : "" }} trouvé{{
        totalItems > 1 ? "s" : ""
        }}
      </span>
    </div>

    <!-- Grille des médecins -->
    <div class="grid grid-cols-1 gap-6">
      <app-card-doctor *ngFor="let doctor of doctors" [doctor]="doctor" [showDistance]="true"
        [showSpecialisation]="true" [showType]="true"></app-card-doctor>
    </div>

    <!-- Pagination -->
    <div *ngIf="totalPages > 1" class="mt-8 flex justify-center">
      <!-- Desktop/tablette: full pagination -->
      <nav class="hidden md:flex items-center space-x-2">
        <button (click)="onPageChange(currentPage - 1)" [disabled]="currentPage === 1"
          class="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
          Précédent
        </button>
        <button *ngFor="let page of getPageNumbers()" (click)="onPageChange(page)" [class]="
            page === currentPage
              ? 'px-3 py-2 text-sm font-medium text-white bg-primary border border-primary rounded-md'
              : 'px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50'
          ">
          {{ page }}
        </button>
        <button (click)="onPageChange(currentPage + 1)" [disabled]="currentPage === totalPages"
          class="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
          Suivant
        </button>
      </nav>

      <!-- Mobile: only prev, current, next -->
      <nav class="flex md:hidden items-center space-x-2">
        <button (click)="onPageChange(currentPage - 1)" [disabled]="currentPage === 1"
          class="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
          ←
        </button>
        <span class="px-3 py-2 text-sm font-medium text-primary bg-gray-100 rounded-md">
          {{ currentPage }} / {{ totalPages }}
        </span>
        <button (click)="onPageChange(currentPage + 1)" [disabled]="currentPage === totalPages"
          class="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
          →
        </button>
      </nav>
    </div>
  </div>

  <!-- Message si aucun médecin trouvé -->
  <div *ngIf="!loading && doctors.length === 0" class="text-center py-12">
    <div class="text-gray-400 mb-4">
      <svg class="mx-auto h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    </div>
    <h3 class="text-lg font-medium text-gray-900 mb-2">Aucun médecin trouvé</h3>
    <p class="text-gray-500">Essayez de modifier vos critères de recherche.</p>
  </div>
</div>


